import { render, staticRenderFns } from "./yitiji.vue?vue&type=template&id=5bff7e68&scoped=true"
var script = {}
import style0 from "./yitiji.vue?vue&type=style&index=0&id=5bff7e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff7e68",
  null
  
)

export default component.exports